import { OfferType } from '@/interfaces/events/Offers'
import { PassType } from '@/interfaces/events/Passes'
import { EventType } from '@/interfaces/events/EventInfo'

interface EventCustomProps {
  offers: OfferType[]
  passes: PassType[]
  routes: {
    event: {
      progress: 'EventsTaskchain' | 'EventsOverview' | 'EventsBoard'
      collection: 'EventsMilestones' | 'EventsOverview'
    }
    passes: {
      // progress: 'EventsPasses'
      'progress.query.pass'?: PassType
      // collection: 'EventsPasses'
      'collection.query.pass'?: PassType
    }
    premium: {
      progress: 'PremiumEventOffers' | 'PremiumEventPasses'
      'progress.query.pass'?: PassType
      collection: 'PremiumEventOffers' | 'PremiumEventPasses'
      'collection.query.pass'?: PassType
    }
  }
}

export const getEventAssetsDirectory = (event_type: string): string => {
  switch (event_type) {
    case EventType.ChallengeCup: {
      return 'challenge-cup'
    }
    case EventType.FrozenChampionship: {
      return 'frozen-championship'
    }
    case EventType.DisciplineEvent: {
      return 'discipline-event'
    }
    case EventType.BoardGamesEvent: {
      return 'board-games-event'
    }
    case EventType.IceAndFireEvent: {
      return 'ice-and-fire-event'
    }
    case EventType.AutumnFair: {
      return 'autumn-fair'
    }
    case EventType.Fortune: {
      return 'fortune-festival'
    }
    default: {
      return event_type
    }
  }
}

export const getEventCustomProps = (event_type: string): EventCustomProps => {
  switch (event_type) {
    case EventType.ChallengeCup:
    case EventType.FrozenChampionship: {
      return {
        offers: [OfferType.Offer],
        passes: [PassType.Event, PassType.Champion],
        routes: {
          event: {
            progress: 'EventsTaskchain',
            collection: 'EventsMilestones',
          },
          passes: {
            // progress: 'EventsPasses',
            'progress.query.pass': PassType.Event,
            // collection: 'EventsPasses',
            'collection.query.pass': PassType.Champion,
          },
          premium: {
            progress: 'PremiumEventOffers',
            'progress.query.pass': undefined,
            collection: 'PremiumEventPasses',
            'collection.query.pass': PassType.Champion,
          },
        },
      }
    }
    case EventType.DisciplineEvent: {
      return {
        offers: [OfferType.Offer],
        passes: [PassType.Master],
        routes: {
          event: {
            progress: 'EventsOverview',
            collection: 'EventsOverview',
          },
          passes: {
            // progress: 'EventsPasses',
            'progress.query.pass': PassType.Master,
            // collection: 'EventsPasses',
            'collection.query.pass': PassType.Master,
          },
          premium: {
            progress: 'PremiumEventOffers',
            'progress.query.pass': undefined,
            collection: 'PremiumEventOffers',
            'collection.query.pass': undefined,
          },
        },
      }
    }
    case EventType.AutumnFair:
    case EventType.Fortune: {
      return {
        offers: [OfferType.Offer],
        passes: [PassType.Event, PassType.Champion],
        routes: {
          event: {
            progress: 'EventsBoard',
            collection: 'EventsMilestones',
          },
          passes: {
            // progress: 'EventsPasses',
            'progress.query.pass': PassType.Event,
            // collection: 'EventsPasses',
            'collection.query.pass': PassType.Event,
          },
          premium: {
            progress: 'PremiumEventOffers',
            'progress.query.pass': undefined,
            collection: 'PremiumEventOffers',
            'collection.query.pass': undefined,
          },
        },
      }
    }
  }
}
